module.exports = __webpack_public_path__ + "img/img-drew-flying.2ca30af2.png";